module.exports = __webpack_public_path__ + "img/mz.3be645da.svg";